import { inject, Injectable } from '@angular/core';
import { ClaimsJsonValidatorService } from 'app/shared/components/debug-tools/claims-json-validator/claims-json-validator.service';
import { IUniversalSearchItem } from 'app/shared/components/universal-search/interfaces/universal-search-item.interface';

@Injectable()
export class DebugToolsConfigService {
    private readonly claimsJsonValidatorService = inject(ClaimsJsonValidatorService);

    public readonly DEBUG_TOOLS_CONFIG: IUniversalSearchItem[] = [
        {
            itemId: 'claims-json-validator',
            materialSymbolsIcon: 'code',
            text: 'Claims JSON Validator',
            action: () => {
                this.claimsJsonValidatorService.open();
            },
        },
    ];
}
